import { Link } from "@StarberryUtils";
import * as React from "react"
import { Container, Row, Col } from 'react-bootstrap';
import ModalTiny from "react-bootstrap/Modal";
import { CloseIcon } from "../../Icons/Icons";
import ValuationFormPage from "../../forms/valuation-form";
import { GetURL } from "../../common/site/functions";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
import "./ServiceTiles.scss";

const ServiceTiles = (props) => {
	//console.log(props)
	const [modalValuationformOpen, setValuationformOpen] = React.useState(false);
	const openValuationformModal = () => {
		setValuationformOpen(true);
	};
	const closeValuationformModal = () => {
		setValuationformOpen(false);
	};
	return (
		<div className="services-tiles-list sec-pdy-120">
			<Container>
				<div className="section-heading">
					<h4>{props?.title || 'Explore Services'}</h4>
				</div>
				<Row>
					{props.data && props.data.map((tile, i) => {

						const image_url = tile.Image.url

						let processedImages = JSON.stringify({});
						if (props.imagetransforms?.Modules?.Add_Service_Tile?.Image_Transforms) {
							processedImages = props.imagetransforms.Modules.Add_Service_Tile.Image_Transforms;
						}
							const ggfx = [{
								...props?.ggfx_results
							}]	
						return (
							<>
								{tile.Link && (
									<div className="col-12 col-md-6 col-xl-3 service-list-wrap">
										<div className="service-list">
											{GetURL(tile.Link.id).includes("valuation") ?
												<a href="javascript:void(0)" onClick={openValuationformModal}>
													<div className="tile-img">
														{/* <ImageTransform
															imagesources={image_url}
															renderer="srcSet"
															imagename="articles.Modules.Add_Service_Tile.Image.tile_image"
															attr={{ alt: `${tile.Label} - Dacha` }}
															imagetransformresult={processedImages}
															id={props.id}
														/> */}
														<ImageModule 
																ImageSrc={tile?.Image } 
																attr={{ alt: tile?.Label + ' - Dacha', class: '' }} 
																ggfx_results={ggfx} 
																imagename="articles.Modules_Add_Service_Tile_Image.tile_image"
																strapi_id={props?.id} 
														/>   
													</div>
													<div className="service-title text-md-bold">{tile.Label}</div>
												</a>
												:
												<Link to={`/${GetURL(tile.Link.id)}`}>
													<div className="tile-img">
														{/* <ImageTransform
															imagesources={image_url}
															renderer="srcSet"
															imagename="articles.Modules_Add_Service_Tile_Image.tile_image"
															attr={{ alt: `${tile.Label} - Dacha` }}
															imagetransformresult={processedImages}
															id={props.id}
														/> */}
														<ImageModule 
																ImageSrc={tile?.Image } 
																attr={{ alt: tile?.Label + ' - Dacha', class: '' }} 
																ggfx_results={ggfx} 
																imagename="articles.Modules_Add_Service_Tile_Image.tile_image" 
																strapi_id={props?.id} 
														/>   
													</div>
													<div className="service-title text-md-bold">{tile.Label}</div>
												</Link>
											}

										</div>
									</div>
								)}
							</>
						)
					})}
				</Row>
			</Container>
			<ModalTiny show={modalValuationformOpen} onHide={closeValuationformModal} className="modal-form-wrapper form-valuation-wrapper">
				<ModalTiny.Header>
					<div class="modal-close-btn" onClick={closeValuationformModal}><CloseIcon /></div>
					<ModalTiny.Title>
						<h4>Property Valuation</h4>
						<p className="text-sm">Receive a Professional Property Valuation in Minutes – Just Fill Out the Form</p>
					</ModalTiny.Title>
				</ModalTiny.Header>
				<ModalTiny.Body>
					<ValuationFormPage />
				</ModalTiny.Body>
			</ModalTiny>
		</div>
	)
}

export default ServiceTiles